import { FC } from 'react';

import img from '../../../assets/images/warning.png';
import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';

export type CapTableWarningModalProps = {
  onClose: () => void;
};

export const CapTableWarningModal: FC<CapTableWarningModalProps> = ({ onClose }) => {
  return (
    <div className="m-2 flex w-full max-w-[453px] flex-col items-center gap-10 rounded bg-white px-4 py-10">
      <div className="flex w-full flex-col items-center gap-6">
        <div
          className="rounded-full bg-white pt-4"
          style={{
            boxShadow: '0px 0px 8px 0px rgba(247, 144, 9, 0.13) inset',
          }}
        >
          <div
            className="centered flex size-28 items-center gap-3 rounded-full"
            style={{
              background:
                ' linear-gradient(180deg, rgba(253, 176, 34, 0.13) 0%, rgba(220, 104, 3, 0.13) 100%)',
            }}
          >
            <div className="size-[56px] object-cover">
              <img alt="" src={img} />
            </div>
          </div>
        </div>
        <span className="max-w-[350px] text-center text-sm font-[450] text-gray-700">
          <AppFormattedMessage id="CAP_TABLE_MIGHT_HAVE_CHANGED" />
        </span>
        <span className="max-w-[350px] text-center text-sm font-[450] text-gray-700">
          <AppFormattedMessage id="WARNING_ABOUT_DATA_ACCURACY_IN_SCENARIO" />
        </span>
      </div>

      <Button className="max-w-[153px]" onClick={onClose}>
        <AppFormattedMessage id="OK_I_UNDERSTAND" />
      </Button>
    </div>
  );
};
